/* eslint-disable import/prefer-default-export */
export function DEFAULT_GET_PREFERRED_REPLACEMENT_STRING(value, replaceIndex, newChar) {
  return value.substring(0, replaceIndex) + newChar + value.substring(replaceIndex + 1);
}

/**
 * Fill the string on the right side with the example value to the given length
 * @param checkValue Initial string to pad
 * @param exampleValue Example value
 * @param length Target length
 * @returns String padded with the given example value
 */
export function fillToLength(checkValue, exampleValue, length) {
  return checkValue.length < length ? "".concat(checkValue).concat(exampleValue.substring(checkValue.length, length)) : checkValue;
}

/**
 * Trim all characters matching the empty mask on the right side of the given value
 * @param value String to trim
 * @param emptyMask Empty mask
 * @returns Trimmed string
 */
export function trimTrailingMask(value, emptyMask) {
  var length = value.length;
  for (var i = value.length - 1; i >= 0; i -= 1) {
    if (emptyMask[i] === value[i]) {
      length = i;
    } else {
      break;
    }
  }
  return value.substring(0, length);
}
//# sourceMappingURL=MaskedInputUtils.js.map